import { Reveal } from "./motion";
import { PILLARS, SERVICES } from "../../lib/siteData";

const Row = ({ pillar, i }) => {
  const flip = i % 2 === 1;
  return (
    <div className="grid grid-cols-1 items-center gap-8 md:grid-cols-12 md:gap-14">
      {/* image */}
      <Reveal
        y={60}
        className={`md:col-span-6 ${flip ? "md:order-2" : ""}`}
      >
        <div className="group relative aspect-[4/3] overflow-hidden rounded-2xl border border-white/10">
          <img
            src={pillar.image}
            alt={pillar.title}
            className="h-full w-full object-cover grayscale transition-all duration-700 ease-out group-hover:scale-105 group-hover:grayscale-0"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" />
          <span className="absolute bottom-6 left-6 font-heading text-6xl md:text-7xl font-bold leading-none text-stroke-brand">
            {pillar.num}
          </span>
        </div>
      </Reveal>

      {/* text */}
      <Reveal delay={0.1} className={`md:col-span-6 ${flip ? "md:order-1 md:pr-8" : "md:pl-8"}`}>
        <h3 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold uppercase tracking-tighter leading-none">
          {pillar.title}
        </h3>
        <p className="mt-5 max-w-lg font-body text-base sm:text-lg font-light leading-relaxed text-neutral-400">
          {pillar.blurb}
        </p>
        <ul className="mt-7 flex flex-col gap-3">
          {pillar.examples.map((ex) => (
            <li key={ex} className="flex items-center gap-3 font-body text-neutral-200">
              <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-brand" />
              {ex}
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  );
};

export const Pillars = () => {
  return (
    <section id="pillars" data-testid="pillars-section" className="relative bg-ink py-28 md:py-40 border-t border-white/10">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <Reveal className="mb-20 md:mb-28 max-w-3xl">
          <span className="font-body text-xs font-bold uppercase tracking-[0.25em] text-brand">How we help</span>
          <h2 className="mt-6 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold uppercase leading-[0.95] tracking-tighter">
            Three ways we help your club
          </h2>
        </Reveal>

        <div className="space-y-24 md:space-y-36">
          {PILLARS.map((p, i) => (
            <Row key={p.key} pillar={p} i={i} />
          ))}
        </div>

        {/* Additional services */}
        <Reveal className="mt-28 md:mt-36 border-t border-white/10 pt-16">
          <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <h3 className="font-heading text-2xl sm:text-3xl font-medium uppercase tracking-tight">
              And plenty more we can take on
            </h3>
            <p className="max-w-md font-body text-sm font-light leading-relaxed text-neutral-500">
              A few examples of where our team can help. If it's taking your volunteers' time, ask us.
            </p>
          </div>
          <div className="mt-10 flex flex-wrap gap-3">
            {SERVICES.map((s, i) => (
              <Reveal
                key={s}
                delay={Math.min(i * 0.03, 0.4)}
                y={16}
                data-testid={`service-chip-${i}`}
                className="rounded-full border border-white/12 bg-white/[0.03] px-4 py-2 font-body text-sm text-neutral-300 transition-colors duration-300 hover:border-brand/60 hover:text-white"
              >
                {s}
              </Reveal>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
